export enum DndTypes {
  CONVERTERS_GROUPS = 'CONVERTERS_GROUPS',
  NONSTANDARD_CONVERTERS = 'NONSTANDARD_CONVERTERS',
  PHOTO_PREVIEW_ITEM = 'PHOTO_PREVIEW_ITEM',
  SELECT = 'SELECT',
}
